// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__iFRcD","title":"ClientInsurance_title__1E-LE","itemText":"ClientInsurance_itemText__2q2fD"};